/* eslint-disable react-hooks/exhaustive-deps */
import  { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Grid,
  InputAdornment,
  TextField,
  LinearProgress,
  Typography,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import DownloadIcon from "@mui/icons-material/Download";
import "./style.css";
import { ZyppLiteApi } from "../../../API/Zypp-Lite-Api/LiteApi";
import { downloadReport } from "../../utils/downloadReport";
const FleetDailyReport = () => {
  const [searchValInput, setSearchValInput] = useState("");
  const [page, setPage] = useState(0);
  const [totalCount, setTotalCount] = useState<any>();
  const [rideEndListData, setRideEndListData] = useState<any[]>([]);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [showErrorSnackbar, setShowErrorSnackbar] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedPlan, setSelectedPlan] = useState<any>(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedVehicleIds, setSelectedVehicleIds] = useState<number[]>([]);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [confirmVehicleIds, setConfirmVehicleIds] = useState<number[]>([]);
  const [snackbarSeverity, setSnackbarSeverity] = useState<"success" | "error">( "success");
  const [downloading, setDownloading] = useState(false);

  const rowsPerPage = 10;
  const pageRange = 5;
  const tableHeaderCellStyle = {
    fontWeight: 600,
    fontSize: "14px",
    color: "#455A64",
    font: "Rubik",
  };
  const tableBodyCellStyle = {
    fontWeight: 400,
    fontSize: "14px",
    color: "#3b3b3b",
    font: "Rubik",
  };
  // Dummy data for tables

  const pageCount = Math.ceil(totalCount / rowsPerPage);


  const handlePageChange = (newPage: number) => {
    const newPageNumber = Math.max(1, Math.min(newPage + 1, pageCount));
    setPage(newPageNumber - 1);
  };

 
  const downloadRC = (item: any) => {
    ZyppLiteApi.api
      ?.downloadDocumentRc(item.vehicleId)
      .then((response) => {
        if (response?.code === 2000 && response?.data?.downloadLink) {
          window.open(response.data.downloadLink, "_blank");
          setSnackbarSeverity("success");
        } else if (response?.code === 400) {
          setSnackbarMessage("RC Document Not Found");
          setShowErrorSnackbar(true);
          setSnackbarSeverity("error");
        } else {
          setSnackbarSeverity("error");
          setSnackbarMessage(
            response?.message || "Error downloading RC document"
          );
          setSnackbarSeverity("error");
          setShowErrorSnackbar(true);
        }
      })
      .catch((error) => {
        console.error("Download RC error: ", error);
        setSnackbarMessage("Failed to download RC document");
        setShowErrorSnackbar(true);
        setSnackbarSeverity("error");
      });
  };
 

  

  const renderPageNumbers = () => {
    const pagesToShow = Math.min(pageCount, pageRange);
    const startPage = Math.max(
      0,
      Math.min(page - Math.floor(pageRange / 2), pageCount - pagesToShow)
    );

    return Array.from({ length: pagesToShow }, (_, index) => {
      const pageNumber = startPage + index + 1;
      return (
        <span
          key={index}
          onClick={() => handlePageChange(pageNumber - 1)}
          className={page === pageNumber - 1 ? "active" : "unactive"}
          style={{ marginLeft: "6px" }}
        >
          {pageNumber}
        </span>
      );
    });
  };

  const handleClearSearch = () => {
    setSearchValInput("");
  };

  const handleDownloadReport = () => {
    downloadReport(
      () => ZyppLiteApi.api.downloadRideEndVehiclesReport(),
      "Ride_Ended_Vehicles_Report.xlsx",
      (msg) => { setSnackbarMessage(msg); setSnackbarSeverity("success"); setShowErrorSnackbar(true); },
      (msg) => { setSnackbarMessage(msg); setSnackbarSeverity("error"); setShowErrorSnackbar(true); },
      setDownloading
    );
  };

  const fetchUserData = () => {
    ZyppLiteApi.api
      ?.rideEndedList(searchValInput, page, rowsPerPage)
      .then((response) => {
        if (response.data.vehicleDetails.length > 0) {
          setRideEndListData(response.data.vehicleDetails);
          setTotalCount(response.data.total);
        } else {
          setRideEndListData([]);
          setTotalCount(1);
        }
      })
      .catch((error) => {
        console.error("API call error: ", error);
      });
  };
  useEffect(() => {
    fetchUserData();
  }, [page, rowsPerPage, searchValInput]);

  
  const handlePlanStatusUpdate = (userId: number, planStatus: string) => {
    const payload = {
      userId,
      planStatus,
    };

    ZyppLiteApi.api
      ?.verifyRentalPlan(payload)
      .then((response: any) => {
        if (response?.code === 2000) {
          setSnackbarMessage("Plan status updated successfully");
          setShowErrorSnackbar(true);
          setSnackbarSeverity("success");
          setAnchorEl(null); // Close popper
          setSelectedPlan(null);
          fetchUserData();
        } else {
          setSnackbarMessage(response?.message || "Plan update failed");
          setSnackbarSeverity("error");
          setShowErrorSnackbar(true);
        }
      })
      .catch((error) => {
        console.error("Plan status update error:", error);
        setSnackbarSeverity("error");
        setSnackbarMessage("Plan update failed");
        setShowErrorSnackbar(true);
      });
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (anchorEl && !anchorEl.contains(event.target as Node)) {
        setAnchorEl(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [anchorEl]);
const updateRideEndStatus = (vehicleIds: number[]) => {
  ZyppLiteApi.api
    ?.updateRideEndStatus(vehicleIds) // ✅ CORRECT
    .then((response: any) => {
      if (response?.code === 2000 || response?.status === 200) {
        setSnackbarMessage("RFA updated successfully");
        setSnackbarSeverity("success");
        setShowErrorSnackbar(true);
        setSelectedVehicleIds([]);
        fetchUserData();
      } else {
        setSnackbarMessage(response?.message || "RFA update failed");
        setSnackbarSeverity("error");
        setShowErrorSnackbar(true);
      }
    })
    .catch(() => {
      setSnackbarMessage("RFA update failed");
      setSnackbarSeverity("error");
      setShowErrorSnackbar(true);
    });
};


  return (
    <div className="p-10">
      <div className="w-full flex bg-white min-h-80 box-shadow p-3 rounded-xl">
        <div className="w-full">
          <Grid container spacing={5} className="w-full flex justify-between ">
            <Grid item md={3}>
              <div className="flex ml-4">
                <h2 className="text-center ml-2 mx-1 mt-2 font-semibold text-2xl text-black pb-2">
                 Ride Ended List
                </h2>
              </div>
            </Grid>
            <Grid item md={9}>
              <div className="flex mr-4">
                <div className="flex w-full justify-end">
                  <div className="mr-3">
                    <TextField
                      placeholder="Search EV No"
                      id="outlined-basic"
                      variant="outlined"
                      onChange={(search: any) =>
                        setSearchValInput(search.target.value)
                      }
                      value={searchValInput}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                        endAdornment: (
                          <InputAdornment
                            position="end"
                            onClick={handleClearSearch}
                          >
                            <ClearIcon style={{ cursor: "pointer" }} />
                          </InputAdornment>
                        ),
                        style: {
                          height: "40px",
                          borderRadius: "25px",
                          width: "350px",
                        },
                      }}
                      // onKeyDown={handleKeyPress}
                    />
                  </div>

                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <Button
                      onClick={handleDownloadReport}
                      disabled={downloading}
                      style={{
                        backgroundColor: "#06B681",
                        padding: "5px 18px",
                        color: "#fff",
                        borderRadius: "40px",
                        textTransform: "none",
                        fontSize: "16px",
                      }}
                    >
                      <DownloadIcon sx={{ mr: 0.5 }} />
                      {downloading ? "Downloading..." : "Download"}
                    </Button>
                    <Button
                      disabled={selectedVehicleIds.length === 0}
                      onClick={() => updateRideEndStatus(selectedVehicleIds)}
                      style={{
                        backgroundColor: "#000",
                        padding: "5px 18px",
                        color: "#fff",
                        borderRadius: "40px",
                        textTransform: "none",
                        opacity: selectedVehicleIds.length === 0 ? 0.6 : 1,
                      }}
                    >
                      Bulk Ready For Allotment
                    </Button>
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
          <hr className="my-4" />

          <TableContainer>
            {!rideEndListData ? ( // Check if API response is still undefined (loading)
              <LinearProgress />
            ) : typeof rideEndListData === "string" ? ( // If API returns "No Data Found" as a string
              <Typography style={{ textAlign: "center", padding: "10px" }}>
                No data available
              </Typography>
            ) : rideEndListData.length === 0 ? ( // If the array is empty
              <Typography style={{ textAlign: "center", padding: "10px" }}>
                No data available
              </Typography>
            ) : (
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell align="center">
  <input
    type="checkbox"
    checked={
      rideEndListData.length > 0 &&
      selectedVehicleIds.length === rideEndListData.length
    }
    onChange={(e) => {
      if (e.target.checked) {
        setSelectedVehicleIds(
          rideEndListData.map((item) => item.vehicleId)
        );
      } else {
        setSelectedVehicleIds([]);
      }
    }}
  />
</TableCell>
                    <TableCell
                      style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                      sx={{ minWidth: 110 }}
                    >
                      Vehicle No
                    </TableCell>
                    <TableCell
                      style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                      sx={{ minWidth: 120 }}
                    >
                     Allotted Date
                    </TableCell>
                    <TableCell
                      style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                      sx={{ minWidth: 120 }}
                    >
                      Fleet Name
                    </TableCell>
                    <TableCell
                      style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                      sx={{ minWidth: 110 }}
                    >
                      IMEI No.
                    </TableCell>
                    <TableCell
                      style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                      sx={{ minWidth: 110 }}
                    >
                      Total Distance
                    </TableCell>
                    <TableCell
                      style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                      sx={{ minWidth: 120 }}
                    >
                     Total CO<sub>2</sub> Saved
                    </TableCell>
                    <TableCell
                      style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                      sx={{ minWidth: 110 }}
                    >
                      Average Speed
                    </TableCell> 

                    
                    <TableCell
                      style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                      sx={{ minWidth: 80 }}
                    >
                      Vehicle Docs
                    </TableCell>
                    <TableCell
                      style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                      sx={{ minWidth: 250 }}
                    >
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rideEndListData.map((item: any, index: any) => (
                    <TableRow key={index}>
                      <TableCell align="center">
  <input
    type="checkbox"
    checked={selectedVehicleIds.includes(item.vehicleId)}
    onChange={(e) => {
      if (e.target.checked) {
        setSelectedVehicleIds((prev) => [...prev, item.vehicleId]);
      } else {
        setSelectedVehicleIds((prev) =>
          prev.filter((id) => id !== item.vehicleId)
        );
      }
    }}
  />
</TableCell>

                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        {item.vehicleNo ? item.vehicleNo : "_"}
                      </TableCell>
                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        {item.allottedDate? item.allottedDate :"_"}
                      </TableCell>
                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                          {item.fleetName? item.fleetName :"_"}
                      </TableCell>

                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                           {item.imei? item.imei :"_"}
                      </TableCell>
                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                         {item.totalDistanceTravelled? item.totalDistanceTravelled :"_"}
                        
                      </TableCell>
                       <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                       {item.totalCarbonSaved? item.totalCarbonSaved :"_"}
                      </TableCell>

                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                         {item.averageSpeed? item.averageSpeed :"_"}
                        
                      </TableCell>

                      
                     <TableCell
                                             style={{ ...tableBodyCellStyle, textAlign: "center" }}
                                           >
                                             <img
                                               src={"/assets/document.svg"}
                                               alt="document"
                                               onClick={() => downloadRC(item)}
                                               style={{
                                                 cursor: "pointer",
                                                 display: "block",
                                                 margin: "auto",
                                               }}
                                             />
                                           </TableCell>
                                            <TableCell
                                             style={{ ...tableBodyCellStyle, textAlign: "center" }}
                                           >
                                          <Button
  style={{
    backgroundColor: "#05B97D",
    padding: "5px 8px",
    color: "#fff",
    borderRadius: "40px",
    textTransform: "none",
  }}
  onClick={() => {
  setConfirmVehicleIds([item.vehicleId]);
  setConfirmDialogOpen(true);
}}

>
  Ready For Allotment
</Button>

                                           </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            )}
          </TableContainer>

          <div className="pl-2 pt-4 pb-2 pr-16">
            <div
              className="pagination"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <div>
                <button
                  onClick={() => handlePageChange(page - 1)}
                  disabled={page === 0}
                  style={{
                    fontFamily: "Rubik",
                    fontSize: "20px",
                    marginRight: "6px",
                  }}
                >
                  {"<"}
                </button>
                {renderPageNumbers()}
                <button
                  onClick={() => handlePageChange(page + 1)}
                  disabled={page >= pageCount - 1}
                  style={{
                    fontFamily: "Rubik",
                    fontSize: "20px",
                    marginLeft: "6px",
                  }}
                >
                  {">"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Snackbar
        open={showErrorSnackbar}
        autoHideDuration={6000}
        onClose={() => setShowErrorSnackbar(false)}
      >
        <Alert severity={snackbarSeverity}>{snackbarMessage}</Alert>
      </Snackbar>
      <Dialog
  open={confirmDialogOpen}
  onClose={() => setConfirmDialogOpen(false)}
>
  <DialogTitle>Confirm Action</DialogTitle>

  <DialogContent>
    <Typography>
      Are you sure you want to mark the selected vehicle(s) as
      <strong> Ready For Allotment</strong>?
    </Typography>
  </DialogContent>

  <DialogActions>
    <Button
      onClick={() => setConfirmDialogOpen(false)}
      variant="outlined"
      sx={{ borderRadius: "20px", textTransform: "none" }}
    >
      Cancel
    </Button>

    <Button
      onClick={() => {
        updateRideEndStatus(confirmVehicleIds);
        setConfirmDialogOpen(false);
      }}
      variant="contained"
      sx={{
        backgroundColor: "#05B97D",
        color: "#fff",
        borderRadius: "20px",
        textTransform: "none",
        px: 3,
      }}
    >
      Accept
    </Button>
  </DialogActions>
</Dialog>

      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>{selectedPlan?.planSelected} Plan</DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="textSecondary">
            Do you want to approve or reject the plan for user:{" "}
            {selectedPlan?.name}?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              if (selectedPlan) {
                handlePlanStatusUpdate(selectedPlan.userId, "APPROVED");
              }
              setOpenDialog(false);
            }}
            variant="contained"
            style={{
              backgroundColor: "#05B97D",
              color: "#fff",
              textTransform: "none",
              borderRadius: "20px",
              padding: "5px 25px",
            }}
          >
            Accept
          </Button>
          <Button
            onClick={() => {
              if (selectedPlan) {
                handlePlanStatusUpdate(selectedPlan.userId, "REJECTED");
              }
              setOpenDialog(false);
            }}
            variant="contained"
            style={{
              backgroundColor: "#F94932",
              color: "#fff",
              textTransform: "none",
              borderRadius: "20px",
              padding: "5px 25px",
            }}
          >
            Reject
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default FleetDailyReport;
